export const LIGHTFIELD_API_KEYS_URL =
  'https://crm.lightfield.app/crm/settings/api-keys';

export interface LightfieldObjectType {
  /** The Ahoy entity type name submitted to the create-import endpoint. */
  name: string;
  /** Ahoy's name for the record type — the user lands on these after import. */
  label: string;
  /**
   * Lightfield's own name, shown only where it diverges from Ahoy's. Contacts
   * are "contacts" in both systems, so only Company carries one.
   */
  description?: string;
}

export const LIGHTFIELD_OBJECT_TYPES: readonly LightfieldObjectType[] = [
  { name: 'ahoy_contact', label: 'Contact' },
  {
    name: 'ahoy_company',
    label: 'Company',
    description: 'Called "Accounts" in Lightfield',
  },
  {
    name: 'ahoy_deal',
    label: 'Deal',
    description: 'Called "Opportunities" in Lightfield',
  },
  {
    name: 'ahoy_note',
    label: 'Note',
    description: 'Lightfield Notes and Tasks both import as Notes',
  },
];

/**
 * Maps a discovered custom object type (backend contract: `{ label,
 * entity_type_name }`) to the normalized `LightfieldObjectType` shape shared
 * with the built-ins. `entity_type_name` becomes `name` — the value the
 * wizard submits back in `selectedObjectTypes`.
 */
export function discoveredTypeToLightfieldObjectType(discovered: {
  label: string;
  entity_type_name: string;
}): LightfieldObjectType {
  return { name: discovered.entity_type_name, label: discovered.label };
}
